import { offersSlice } from './offers/offers.slice';

// TODO: review all usages from this file after removing all unused loyalty LD flags

type LoyaltyActions = typeof offersSlice.actions;
// Exporting all actions from slices in one file mimics exported variables from a context and encourages more explicit naming
// As an added benefit, we are able to see which actions come from which slice in a central location

const {
  applyOffer,
  removeAppliedOfferByCartEntry,
  resetAppliedOffers,
  setSelectedOffer,
} = offersSlice.actions;

export const loyaltyActions: LoyaltyActions = {
  // Offers slice actions
  applyOffer,
  removeAppliedOfferByCartEntry,
  resetAppliedOffers,
  setSelectedOffer,
};
